<template>
  <div
    class="clearfix mt15pb20 mb20"
    data-test="intro"
  >
    <job-preview-right-column
      :text-count-mode="textCountMode"
      :highlight-mode="highlightMode"
      comment-class="feature"
      :comment-highlights="commentHighlights"
      text-count-class="company-info"
      :text-counts="textCounts"
      v-on="$listeners"
    />
    <div class="tl fll row-left">
      <p
        v-if="catchCopy"
        :id="targetIdMap.companyInfo.intro.catchCopy"
        class="fwB fs15 mb10"
        data-test="intro-catch"
        v-text="catchCopy"
      />
      <p
        v-if="text"
        :id="targetIdMap.companyInfo.intro.text"
        class="pega-pre-wrap"
        data-test="intro-text"
        v-text="text"
      />
    </div>
    <div class="flr ml25 company-img-main">
      <img
        v-if="image && image.id"
        :id="targetIdMap.companyInfo.intro.image"
        :src="getPhotoUrl(image)"
        data-test="introImage"
        @load="$emit('onLoadImage')"
        @error="$emit('onLoadImage')"
      >
    </div>
  </div>
</template>

<style scoped lang="scss">
@use "@/styles/preview/pc/offer/base" as *;
</style>

<script>
import JobPreviewRightColumn from '@/components/molecules/JobPreviewRightColumn'
import jobPreviewCommon from '@/lib/jobPreviewCommon'
export default {
  components: {
    JobPreviewRightColumn
  },
  mixins: [jobPreviewCommon],
  props: {
    highlightMode: {
      type: Boolean,
      default: false
    },
    commentHighlights: {
      type: Array,
      default: () => []
    },
    textCountMode: {
      type: Boolean,
      default: false
    },
    textCounts: {
      type: Array,
      default: () => []
    },
    catchCopy: {
      type: String,
      default: ''
    },
    text: {
      type: String,
      default: ''
    },
    image: {
      type: Object,
      default: null
    }
  }
}
</script>
